import { createContext, useContext, useState } from "react";

const DnDContext = createContext([null, (_) => {}]);

export const DnDProvider = ({ children }) => {
    const [dragNodeData, setDragNodeData] = useState(null);

    return (
        <DnDContext.Provider value={[dragNodeData, setDragNodeData]}>
            {children}
        </DnDContext.Provider>
    );
}

export default DnDContext;

export const useDnD = () => {
    return useContext(DnDContext);
}